module.exports = __webpack_public_path__ + "static/media/PAP.ed260297.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PAP.svg
// module id = 625
// module chunks = 0